

/**
 * Extract the file name from HTTP Content-Disposition header value, 
 * for instance 'form-data; name="myFile"; filename="foo.txt"' returns 'foo.txt'.
 * 
 * @param contentDispositionHeader HTTP Content-Disposition header value.
 */
export function extractFileNameFromHeader(contentDispositionHeader: string) {
    return contentDispositionHeader
    ?.split(';')
    ?.find((n: string) => n.includes('filename='))
    ?.replace('filename=', '')
    .replaceAll('"', '')
    .trim();
}

/**
 * Start download from axios response.
 * @param filename the name of the file to download.
 * @param content the content of the file to download.
 * @param contentType the content-type... of the file to download.
 */
export function     startFileDownload(filename: string, content: any, contentType: string) :void {

    const file = new Blob([content], { type: contentType });
    const downloadUrl = window.URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

}

const features = {
    extractFileNameFromHeader,
    startFileDownload,
};

export default features;